enum EMediaDevices {
  COARSE = "coarse",
  FINE = "fine",
  HOVER = "hover",
  NONE = "none",
  ALL = "all"
}

export default EMediaDevices;
